import {
    Box,
    Button,
    Fab,
    IconButton,
    Paper,
    Tooltip,
    Typography
} from "@mui/material";
import { useContext, useEffect, useState } from "react";

import EditIcon from '@material-ui/icons/Edit';
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import {
    DndContext,
    PointerSensor,
    TouchSensor,
    closestCenter,
    useSensor,
    useSensors
} from "@dnd-kit/core";
import PreferenceCard from "./PreferenceCard";
import RoundSelector from "./RoundSelector";

import {
    SortableContext,
    arrayMove,
    verticalListSortingStrategy
} from "@dnd-kit/sortable";
import AddCollegeModal from "./AddCollegeModal";
import BranchSelectModal from "./BranchSelectModal";


import {
    Alert,
    Snackbar
} from "@mui/material";
import { LoginContext } from "../../../contexts/LoginContext";
import {
    createPreferenceRound,
    getUserAllotments,
    getUserPreferences,
    saveUserAllotment,
    saveUserPreferences
} from "../../../services/UserPreferenceListing/userPreferenceService";

import FiltersBar from "./FiltersBar";
import MultiSelectDialog from "./MultiSelectDialog";
import SuggestionsPanel from "./SuggestionsPanel";



import { configUrl } from "../../../config";
import { getPredictedColleges, getPredictorFilters } from "../../../services/UserPreferenceListing/CollegePredictorService";

const PreferenceList = ({ predictor, handleBack }) => {

    const [rounds, setRounds] = useState([
        {
            id: 1,
            name: "CAP Round 1",
            list: []
        }
    ]);

    const [activeRound, setActiveRound] = useState(0);
    const [collegeModalOpen, setCollegeModalOpen] = useState(false);

    const [branchModalOpen, setBranchModalOpen] = useState(false);

    const [selectedCollege, setSelectedCollege] = useState(null);

    const currentList = rounds[activeRound]?.list || [];
    const { UserId, userDetail } = useContext(LoginContext);
    const userId = userDetail?.userId || UserId;

    const predictorExam = predictor ?? userDetail?.predictorType;

    const [loading, setLoading] = useState(true);

    const [saving, setSaving] = useState(false);

    const [savedRounds, setSavedRounds] = useState([]);

    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

    const [isEditing, setIsEditing] = useState(false);

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success"
    });

    const [mode, setMode] = useState("list");

    const [suggestions, setSuggestions] = useState([]);

    const [suggestionLoading, setSuggestionLoading] = useState(false);

    const [branchModal, setBranchModal] = useState(false);

    const [typeModal, setTypeModal] = useState(false);

    const [collegeOptions, setCollegeOptions] = useState([]);

    const [allotments, setAllotments] = useState([]);

    const [allotmentLoading, setAllotmentLoading] = useState(false);

    const [selectedAllotment, setSelectedAllotment] = useState(null);

    const [allotmentModalOpen, setAllotmentModalOpen] = useState(false);

    const [allotmentBranchModalOpen, setAllotmentBranchModalOpen] = useState(false);

    const [allotmentCollege, setAllotmentCollege] = useState(null);

    const [categoryModal, setCategoryModal] = useState(false);

    const [collegeBranchMap, setCollegeBranchMap] = useState({});

    const [filters, setFilters] = useState({
        category: predictorExam == 'jee' ? "JEE" : "OPEN",
        branch: [],
        city: "All",
        type: "General"
    });
    const categoryTypeOptions = [
        "General",
        "Ladies",
    ];

    // 
    const [branchOptions, setBranchOptions] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 5
            }
        }),
        useSensor(TouchSensor, {
            activationConstraint: {
                delay: 150,
                tolerance: 5
            }
        })
    );
    // 
    const getStatus = (rank, highestRank) => {
        if (rank <= highestRank * 0.8) return "High Chance";
        if (rank <= highestRank * 1.1) return "Moderate Chance";
        return "Low Chance";
    };
    const dedupeSuggestions = (data) => {
        const map = new Map();

        data?.forEach(item => {
            const key = `${item["College Code"]}_${item["Branch"]}`;

            if (!map.has(key)) {
                map.set(key, item);
            }
        });

        return Array.from(map.values());
    };
    const fetchSuggestions = async () => {

        try {

            setSuggestionLoading(true);

            const rank = predictorExam == "jee" ? userDetail?.jeeRank : userDetail?.mhtcetRank;

            if (!rank) {
                setSuggestionLoading(false);
                return;
            }
            const selectedBranches =
                filters.branch.includes("All")
                    ? []
                    : filters.branch;
            const response =
                await getPredictedColleges(
                    predictorExam,
                    rank,
                    selectedBranches,
                    filters?.category,
                    filters?.city,
                    filters?.type
                );

            const data = Array.isArray(response)
                ? response
                : [];
            const cleanedData = dedupeSuggestions(data);

            const enriched = cleanedData.map(item => ({

                id: `${item["College Code"]}_${item["Branch"]}_${item["Index"]}`,

                college:
                    item["AbbreviatedName"] ||
                    item["College"],

                branch: item["Branch"],

                collegeCode:
                    item["College Code"],

                city: item["City"],

                rank: item["Rank"],
                seats: item["SI"],
                totalSeats: item["Seats Cap1"],

                status: getStatus(rank, item["Highest Rank"])
            }));

            setSuggestions(enriched);

        } catch (err) {

            console.error(err);

            setSuggestions([]);

        } finally {

            setSuggestionLoading(false);
        }
    };


    const loadInitialData = async () => {

        try {

            setLoading(true);

            const responseData = await getUserPreferences(predictorExam, userId);

            const apiRounds =
                responseData?.rounds?.$values || [];

            if (apiRounds.length > 0) {

                const formattedRounds = apiRounds.map(r => ({

                    id: r.id,

                    name: `CAP Round ${r.roundNumber}`,

                    list: r?.preferences?.$values?.map(
                        (p, index) => ({
                            id: `${p.id}`,
                            preferenceId: p.id,
                            college: p.collegeName,
                            branch: p.branchName,
                            collegeCode: p.collegeCode,
                            position: index + 1
                        })
                    ) || []

                }));

                setRounds(formattedRounds);

                setSavedRounds(formattedRounds);

            } else {

                const newRound = await createPreferenceRound({
                    userId: userId,
                    exam: predictorExam
                });

                const initialRound = {
                    id: newRound.id,
                    name: `CAP Round ${newRound.roundNumber}`,
                    list: []
                };

                setRounds([initialRound]);

                setSavedRounds([initialRound]);
            }

        } catch (err) {

            console.error(err);

        } finally {

            setLoading(false);
        }
    };

    const fetchFilters = async () => {

        try {

            const data = await getPredictorFilters(
                predictorExam
            );

            if (!data) return;

            setBranchOptions(
                [...new Set(data?.branches || [])]
            );

            setCityOptions(
                [...new Set(data?.cities || [])]
            );

            if (predictorExam == 'jee') {
                setCategoryOptions(
                    [...new Set(
                        ["JEE", "NEET", "MHT-CET", "MHT-CET-PCM", "MHT-CET-PCB"]
                    )]
                );
            } else {
                setCategoryOptions(
                    [...new Set(
                        (data?.categories || []).filter(
                            item => item !== "All"
                        )
                    )]
                );
            }


            const collegeList = Object.entries(
                data?.collegesWithCodes || {}
            )
                .map(([code, name]) => ({
                    code,
                    name
                }))
                .sort((a, b) =>
                    a.name.localeCompare(b.name)
                );

            setCollegeOptions(collegeList);

        } catch (error) {

            console.error(
                "Error fetching filter options:",
                error
            );
        }
    };

    const loadAllotments = async () => {

        try {

            setAllotmentLoading(true);

            const response = await getUserAllotments(predictorExam, userId);

            const data =
                response?.$values || response || [];

            setAllotments(data);

        } catch (err) {

            console.error(err);

        } finally {

            setAllotmentLoading(false);
        }
    };

    useEffect(() => {

        if (mode !== "suggestions") return;

        fetchSuggestions();

    }, [
        mode,
        filters.category,
        filters.city,
        filters.type,
        JSON.stringify(filters.branch)
    ]);

    useEffect(() => {

        if (!userId || !predictorExam) return;

        loadInitialData();
        fetchPreferenceData();
        fetchFilters();
        loadAllotments();

    }, [userId, predictorExam]);

    const handleSave = async () => {

        try {

            setSaving(true);

            const currentRound = rounds[activeRound];

            const payload = currentRound.list.map(item => ({
                userId: userId,
                roundId: currentRound.id,
                collegeCode: item.collegeCode?.toString(),
                collegeName: item.college,
                branchName: item.branch
            }));

            await saveUserPreferences(predictorExam, payload);

            setSavedRounds(rounds);

            setHasUnsavedChanges(false);

            setIsEditing(false);

            setSnackbar({
                open: true,
                message: "Preferences saved successfully",
                severity: "success"
            });

        } catch (err) {

            console.error(err);

            setSnackbar({
                open: true,
                message: "Failed to save preferences",
                severity: "error"
            });

        } finally {

            setSaving(false);
        }
    };

    const addRound = async () => {

        try {

            if (rounds.length >= 4) {

                setSnackbar({
                    open: true,
                    message: "Maximum 4 rounds allowed",
                    severity: "warning"
                });

                return;
            }

            const newRound = await createPreferenceRound({
                userId: userId,
                exam: predictorExam
            });

            const newRoundObj = {
                id: newRound.id,
                name: `CAP Round ${newRound.roundNumber}`,
                list: []
            };

            setRounds(prev => {

                const updatedRounds = [
                    ...prev,
                    newRoundObj
                ];

                // switch automatically to new round
                setActiveRound(updatedRounds.length - 1);

                return updatedRounds;
            });

        } catch (err) {

            console.error(err);

            setSnackbar({
                open: true,
                message: "Failed to create round",
                severity: "error"
            });
        }
    };

    const deleteCollege = (id) => {
        setHasUnsavedChanges(true);
        setRounds(prev =>
            prev.map((round, index) => {

                if (index !== activeRound) return round;

                const updated = round.list
                    .filter(item => item.id !== id)
                    .map((item, idx) => ({
                        ...item,
                        position: idx + 1
                    }));

                return {
                    ...round,
                    list: updated
                };
            })
        );

    };
    const handleDragEnd = (event) => {

        const { active, over } = event;

        if (!over || active.id === over.id) return;
        setHasUnsavedChanges(true);
        const oldIndex = currentList.findIndex(
            item => item.id === active.id
        );

        const newIndex = currentList.findIndex(
            item => item.id === over.id
        );

        const reordered = arrayMove(
            currentList,
            oldIndex,
            newIndex
        ).map((item, index) => ({
            ...item,
            position: index + 1
        }));

        setRounds(prev =>
            prev.map((round, index) =>
                index === activeRound
                    ? {
                        ...round,
                        list: reordered
                    }
                    : round
            )
        );
    };
    const handleSelectCollege = async (code) => {
        try {

            const collegeData = collegeBranchMap?.[code];

            if (!collegeData) {
                console.log("College not found for code:", code);
                return;
            }

            setSelectedCollege({
                code,
                name: collegeData.name,
                branches: collegeData.branches || []
            });

            setCollegeModalOpen(false);

            setBranchModalOpen(true);

        } catch (err) {
            console.error(err);
        }
    };
    const fetchPreferenceData = async () => {
        try {

            const res = await fetch(
                `${configUrl.PredictorServer}/preference-data/${predictorExam}`
            );

            const data = await res.json();

            const map = {};

            data?.colleges?.forEach(college => {

                map[college.code] = {
                    name: college.name,
                    branches: college.branches.map(b =>
                        typeof b === "string" ? b : b.name
                    )
                };
            });

            setCollegeBranchMap(map);

        } catch (err) {
            console.error("Preference data error", err);
        }
    };

    const handleSelectBranch = (branch) => {

        if (!selectedCollege) return;

        const alreadyExists = currentList.some(
            item =>
                item.collegeCode === selectedCollege.code &&
                item.branch === branch
        );

        if (alreadyExists) {

            setSnackbar({
                open: true,
                message: "College already added",
                severity: "warning"
            });

            return;
        }

        setHasUnsavedChanges(true);

        const newItem = {
            id: `${selectedCollege.code}_${branch}_${Date.now()}`,
            college: selectedCollege.name,
            branch,
            collegeCode: selectedCollege.code,
            position: currentList.length + 1
        };

        setRounds(prev =>
            prev.map((round, index) =>
                index === activeRound
                    ? {
                        ...round,
                        list: [...round.list, newItem]
                    }
                    : round
            )
        );

        setBranchModalOpen(false);

        setSelectedCollege(null);
    };

    if (loading) {

        return (
            <Box sx={{ p: 4 }}>
                Loading preferences...
            </Box>
        );
    }

    const handleSuggestionAdd = (item) => {

        const alreadyExists = currentList.some(
            existing =>
                existing.collegeCode === item.collegeCode &&
                existing.branch === item.branch
        );

        if (alreadyExists) {

            setSnackbar({
                open: true,
                message: "College already added",
                severity: "warning"
            });

            return;
        }

        setHasUnsavedChanges(true);

        const newItem = {
            id: `${item.collegeCode}_${item.branch}_${Date.now()}`,
            college: item.college,
            branch: item.branch,
            collegeCode: item.collegeCode,
            position: currentList.length + 1
        };

        setRounds(prev =>
            prev.map((round, index) =>
                index === activeRound
                    ? {
                        ...round,
                        list: [...round.list, newItem]
                    }
                    : round
            )
        );

        // setMode("list");
    };
    console.log("UserId List:", UserId, "UserId Context:", userId);
    const saveAllotment = async () => {

        try {

            const payload = {
                userId: userId,
                exam: predictorExam,
                roundNumber: activeRound + 1,
                collegeCode: selectedAllotment.collegeCode,
                collegeName: selectedAllotment.college,
                branchName: selectedAllotment.branch,
                category: selectedAllotment.category,
                allotmentType: "CAP",
                status: selectedAllotment.status
            };

            await saveUserAllotment(payload);

            setSnackbar({
                open: true,
                message: "Allotment saved successfully",
                severity: "success"
            });

            setSelectedAllotment(null);

            loadAllotments();

        } catch (err) {

            console.error(err);

            setSnackbar({
                open: true,
                message: "Failed to save allotment",
                severity: "error"
            });
        }
    };

    const handleAllotmentCollegeSelect = (code) => {

        const collegeData = collegeBranchMap?.[code];

        if (!collegeData) {
            console.log("College not found for code:", code);
            return;
        }

        setAllotmentCollege({
            code,
            name: collegeData.name,
            branches: collegeData.branches || []
        });

        setAllotmentModalOpen(false);

        setAllotmentBranchModalOpen(true);
    };
    const handleAllotmentBranchSelect = (branch) => {

        if (!allotmentCollege) return;

        setSelectedAllotment({
            college: allotmentCollege.name,
            collegeCode: allotmentCollege.code,
            branch,
            category: filters.category,
            type: filters.type,
            status: "Allotted"
        });

        setAllotmentBranchModalOpen(false);

        setAllotmentCollege(null);
    };

    return (
        <Box sx={{ maxWidth: 1100, margin: "0 auto" }}>

            {/* HEADER */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    justifyContent: 'space-between',
                    alignItems: { xs: 'flex-start', md: 'center' },
                    gap: 2,
                    mb: 3
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1.5,
                        width: { xs: '100%', md: 'auto' },
                        justifyContent: {
                            xs: 'flex-start',
                            md: 'flex-start'
                        }
                    }}
                >
                    {mode === 'list' && (
                        <div style={{ textAlign: 'left' }}>
                            <button onClick={() => handleBack()} style={backButtonStyle}>
                                ← Back
                            </button>
                        </div>
                    )}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                        }}
                    >
                        {/* TITLE */}
                        <Typography
                            variant="h4"
                            fontWeight={600}
                            sx={{
                                fontSize: {
                                    xs: '1.2rem',
                                    sm: '1.5rem'
                                },
                                textAlign: {
                                    xs: 'left',
                                    md: 'left'
                                },
                            }}
                        >
                            {mode === 'list'
                                ? 'Your Preference List'
                                : `College Suggestions for CAP Round ${activeRound + 1}`}
                        </Typography>
                        {/* SUBTITLE */}
                        <Typography
                            variant="h6"
                            // fontWeight={600}
                            sx={{
                                fontSize: {
                                    xs: '1.2rem',
                                    sm: '1.5rem'
                                },
                                textAlign: {
                                    xs: 'left',
                                    md: 'left'
                                },
                                color: '#594e4e',
                                fontFamily: 'Poppins',
                                fontStyle: 'italic',
                            }}
                        >
                            {mode === 'list'
                                ? 'Manage your college preferences for each CAP Round.'
                                : `Add AI-suggested colleges to your preferences.`}
                        </Typography>
                    </Box>

                </Box>


                {/* ROUND SELECTOR */}
                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1.5,
                        width: { xs: '100%', md: 'auto' },
                        justifyContent: {
                            xs: 'flex-start',
                            md: 'flex-end'
                        }
                    }}
                >
                    {
                        mode === 'list' ? (
                            <RoundSelector
                                rounds={rounds}
                                activeRound={activeRound}
                                setActiveRound={setActiveRound}
                                onAddRound={addRound}
                            />
                        ) : (
                            <Button
                                variant="contained"
                                onClick={() =>
                                    setMode(
                                        mode === 'list'
                                            ? 'suggestions'
                                            : 'list'
                                    )
                                }
                                sx={{
                                    backgroundColor: '#002147',
                                    color: '#fff',
                                    textTransform: 'none',
                                    width: { xs: '100%', sm: 'auto' },
                                    padding: '8px 16px',
                                    fontFamily: 'Poppins',
                                    fontWeight: 100,
                                    fontSize: 11,
                                    '&:hover': {
                                        backgroundColor: '#002147'
                                    }
                                }}
                            >
                                Back to Preferences
                                {/* {mode === 'list'
                                    ? 'Browse Suggestions'
                                    : 'Back to Preferences'} */}
                            </Button>
                        )
                    }
                </Box>
            </Box>
            {
                hasUnsavedChanges && (

                    <Alert
                        severity="warning"
                        sx={{
                            mt: 2,
                            borderRadius: 2,
                            fontFamily: "Poppins",
                            fontSize: "0.95rem"
                        }}
                    >
                        You have unsaved changes.
                        Please save your preference list.
                    </Alert>

                )
            }
            <div
                style={{
                    width: "100%",
                    height: "1px",
                    background: "#e5e7eb",
                    margin: "2px 0"
                }}
            />
            {/* round specific results */}
            <div style={{ padding: '5px 5px 10px 10px', border: '1px solid #e5e7eb', borderRadius: '4px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', backgroundColor: '#f9fafb', marginBottom: '16px' }}>
                {/*  ACTION BUTTONS + ALLOTMENT SECTION */}
                {mode === 'list' && (<Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: '1fr',
                            md: '1fr 1fr'
                        },
                        gap: 3,
                        alignItems: 'start',
                        mt: 2
                    }}
                >
                    {/* ACTION BUTTONS */}
                    <Box
                        sx={{
                            // width: { xs: '100%', lg: '280px' },
                            // flex: 1,
                            width: '100%',
                            flexShrink: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1.5,
                            alignItems: {
                                xs: 'stretch',
                                lg: 'flex-start'
                            }
                        }}
                    >
                        {/* <RoundSelector
                        rounds={rounds}
                        activeRound={activeRound}
                        setActiveRound={setActiveRound}
                        onAddRound={addRound}
                    /> */}
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 600,
                                fontFamily: 'Poppins',
                                mb: 1,
                                textAlign: {
                                    xs: 'center',
                                    lg: 'left'
                                }
                            }}
                        >
                            CAP Round {activeRound + 1}
                        </Typography>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: {
                                    xs: 'column',
                                    md: 'row'
                                },
                                gap: 1.5,
                                width: '100%'
                                // alignItems: 'stretch'
                            }}
                        >

                            {!isEditing && mode === 'list' && (
                                <Button
                                    variant="outlined"
                                    onClick={() => setIsEditing(true)}
                                    disabled={currentList.length === 0}
                                    sx={{
                                        color: '#002147',
                                        borderColor: '#002147',
                                        fontFamily: 'Poppins',
                                        textTransform: 'none',
                                        width: { xs: '100%', sm: 'auto' },
                                        padding: '8px 16px',
                                        fontSize: 11,
                                        '&:hover': {
                                            borderColor: '#002147'
                                        }
                                    }}
                                >
                                    {hasUnsavedChanges
                                        ? 'Edit & Save'
                                        : 'Edit List'}
                                </Button>
                            )}

                            {isEditing && mode === 'list' && (
                                <Button
                                    variant="contained"
                                    onClick={handleSave}
                                    disabled={saving}
                                    sx={{
                                        backgroundColor: saving
                                            ? '#0021474e'
                                            : '#002147',
                                        color: '#fff',
                                        fontFamily: 'Poppins',
                                        textTransform: 'none',
                                        width: { xs: '100%', sm: 'auto' },
                                        padding: '8px 16px',
                                        fontWeight: 100,
                                        fontSize: 11,
                                        '&:hover': {
                                            backgroundColor: '#002147'
                                        }
                                    }}
                                >
                                    {saving ? 'Saving...' : 'Save'}
                                </Button>
                            )}
                            <Button
                                variant="contained"
                                onClick={() =>
                                    setMode(
                                        mode === 'list'
                                            ? 'suggestions'
                                            : 'list'
                                    )
                                }
                                sx={{
                                    backgroundColor: '#002147',
                                    color: '#fff',
                                    textTransform: 'none',
                                    width: { xs: '100%', sm: 'auto' },
                                    padding: '8px 16px',
                                    fontFamily: 'Poppins',
                                    fontWeight: 100,
                                    fontSize: 11,
                                    '&:hover': {
                                        backgroundColor: '#002147'
                                    }
                                }}
                            >
                                {mode === 'list'
                                    ? 'Browse AI-Suggestions'
                                    : 'Back to Preferences'}
                            </Button>
                        </Box>
                    </Box>

                    {/* ALLOTMENT SECTION */}
                    <Box
                        sx={{
                            flex: 1,
                            width: '100%'
                        }}
                    >
                        {(() => {
                            const savedAllotment = allotments.find(
                                item => item.roundNumber === activeRound + 1
                            );

                            // UNSAVED SELECTED
                            if (selectedAllotment) {
                                return (
                                    <Paper
                                        elevation={2}
                                        sx={{
                                            p: 2,
                                            borderRadius: 2,
                                            border: '1px solid #fde68a',
                                            backgroundColor: '#fffdf5'
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'flex-start',
                                                gap: 2,
                                                mb: 1
                                            }}
                                        >
                                            <Typography
                                                fontWeight={600}
                                                color="#b45309"
                                                sx={{
                                                    fontSize: {
                                                        xs: '0.9rem',
                                                        sm: '1rem'
                                                    }
                                                }}
                                            >
                                                Selected (Not Saved)
                                            </Typography>

                                            <IconButton
                                                color="error"
                                                onClick={() => setSelectedAllotment(null)}
                                            >
                                                <DeleteOutlineIcon />
                                            </IconButton>
                                        </Box>

                                        <Typography
                                            fontWeight={700}
                                            sx={{
                                                textAlign: 'left',
                                                wordBreak: 'break-word',
                                                fontSize: {
                                                    xs: '0.95rem',
                                                    sm: '1.1rem'
                                                }
                                            }}
                                        >
                                            {selectedAllotment.college} (
                                            {selectedAllotment.branch})
                                        </Typography>
                                    </Paper>
                                );
                            }

                            // EMPTY
                            if (!savedAllotment) {
                                return (
                                    <Paper
                                        elevation={1}
                                        sx={{
                                            p: 3,
                                            borderRadius: 2,
                                            textAlign: 'center',
                                            height: '100%'
                                        }}
                                    >
                                        <Typography color="text.secondary" sx={{ fontFamily: 'Poppins', fontSize: 12 }}>
                                            {`No allotment for CAP round ${activeRound + 1}`}
                                        </Typography>

                                        <Button
                                            variant="outlined"
                                            sx={{
                                                mt: 2,
                                                borderColor: '#002147',
                                                color: '#002147',
                                                fontFamily: 'Poppins',
                                                fontWeight: 600,
                                                textTransform: 'none',
                                                '&:hover': {
                                                    borderColor: '#002147',
                                                    backgroundColor: '#00214736',
                                                    color: '#002147'
                                                }
                                            }}
                                            onClick={() =>
                                                setAllotmentModalOpen(true)
                                            }
                                        >
                                            + Allotment
                                        </Button>
                                    </Paper>
                                );
                            }

                            // SAVED
                            return (
                                <Paper
                                    elevation={1}
                                    sx={{
                                        p: { xs: 2, sm: 3 },
                                        pt: { xs: 5, sm: 4 },
                                        borderRadius: 2,
                                        borderColor: '#002147',
                                        // backgroundColor: '#f0fdf4',
                                        position: 'relative',
                                        overflow: 'hidden',
                                        height: '100%'
                                    }}
                                >
                                    {/* Top Left Text */}
                                    <Typography
                                        sx={{
                                            position: 'absolute',
                                            top: 10,
                                            left: 16,
                                            fontSize: {
                                                xs: '0.8rem',
                                                sm: '1rem'
                                            },
                                            fontWeight: 600,
                                            color: '#002147',
                                            fontFamily: 'Poppins'
                                        }}
                                    >
                                        🎉 Your Allotted College
                                    </Typography>

                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: {
                                                xs: 'column',
                                                sm: 'row'
                                            },
                                            justifyContent: 'space-between',
                                            alignItems: {
                                                xs: 'flex-start',
                                                sm: 'center'
                                            },
                                            gap: 2
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                flex: 1,
                                                width: '100%'
                                            }}
                                        >
                                            <Typography
                                                variant="h6"
                                                sx={{
                                                    fontWeight: 700,
                                                    color: 'success.main',
                                                    fontSize: {
                                                        xs: '1rem',
                                                        sm: '1.25rem'
                                                    },
                                                    wordBreak: 'break-word',
                                                    lineHeight: 1.4
                                                }}
                                            >
                                                {savedAllotment.collegeName} (
                                                {savedAllotment.branchName})
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    mt: 0.5,
                                                    color: '#594e4e',
                                                    fontFamily: 'Poppins',
                                                    fontSize: {
                                                        xs: '0.8rem',
                                                        sm: '0.9rem'
                                                    }
                                                }}
                                            >
                                                Status:{' '}
                                                <strong>
                                                    {savedAllotment.status}
                                                </strong>
                                                {' | '}
                                                Category:{' '}
                                                <strong>
                                                    {savedAllotment.category}
                                                </strong>
                                            </Typography>
                                        </Box>

                                        <Button
                                            size="small"
                                            onClick={() =>
                                                setAllotmentModalOpen(true)
                                            }
                                            sx={{
                                                minWidth: 'auto',
                                                color: '#002147',
                                                fontFamily: 'Poppins',
                                                fontSize: {
                                                    xs: '1rem',
                                                    sm: '1.2rem'
                                                },
                                                fontWeight: 600,
                                                alignSelf: {
                                                    xs: 'flex-end',
                                                    sm: 'center'
                                                }
                                            }}
                                        >
                                            <EditIcon fontSize="medium" />
                                        </Button>
                                    </Box>
                                </Paper>
                            );
                        })()}

                        {/* SAVE BUTTON */}
                        {selectedAllotment && (
                            <Button
                                variant="contained"
                                fullWidth
                                sx={{
                                    mt: 2,
                                    backgroundColor: '#002147',
                                    color: '#fff',
                                    fontFamily: 'Poppins',
                                    textTransform: 'none',
                                    '&:hover': {
                                        backgroundColor: '#002147'
                                    }
                                }}
                                onClick={saveAllotment}
                            >
                                Save Allotment
                            </Button>
                        )}
                    </Box>
                </Box>)}




                {/* MAIN CONTENT */}

                {
                    mode === "list" ? (

                        <>
                            {/* EMPTY STATE */}

                            {currentList.length === 0 ? (

                                <Paper
                                    elevation={0}
                                    sx={{
                                        mt: 2,
                                        p: 4,
                                        textAlign: "center",
                                        border: "1px dashed #ccc",
                                    }}
                                >
                                    <Typography sx={{
                                        fontSize: 14,
                                        fontFamily: "Poppins",
                                        color: "#002147"
                                    }}>
                                        Sort by adding colleges or browsing AI suggestions to build your CAP preference list.
                                    </Typography>
                                </Paper>

                            ) : (
                                <Box sx={{ mt: 2 }}>

                                    <DndContext
                                        sensors={sensors}
                                        collisionDetection={closestCenter}
                                        onDragEnd={handleDragEnd}
                                    >

                                        <SortableContext
                                            items={currentList.map(item => item.id)}
                                            strategy={verticalListSortingStrategy}
                                        >

                                            <Box
                                                sx={{
                                                    display: "grid",
                                                    gridTemplateColumns: {
                                                        xs: "1fr",
                                                        sm: "1fr 1fr",
                                                        md: "1fr 1fr"
                                                    },
                                                    gap: 0.5
                                                }}
                                            >

                                                {currentList.map(item => (

                                                    <PreferenceCard
                                                        key={item.id}
                                                        item={item}
                                                        onDelete={deleteCollege}
                                                        isEditing={isEditing}
                                                    />

                                                ))}

                                            </Box>

                                        </SortableContext>

                                    </DndContext>

                                </Box>
                                // 1card in a row 
                                // <Box sx={{ mt: 1 }}>

                                //     <DndContext
                                //         collisionDetection={closestCenter}
                                //         onDragEnd={handleDragEnd}
                                //     >

                                //         <SortableContext
                                //             items={currentList.map(item => item.id)}
                                //             strategy={verticalListSortingStrategy}
                                //         >

                                //             {currentList.map(item => (

                                //                 <PreferenceCard
                                //                     key={item.id}
                                //                     item={item}
                                //                     onDelete={deleteCollege}
                                //                     isEditing={isEditing}
                                //                 />

                                //             ))}

                                //         </SortableContext>

                                //     </DndContext>

                                // </Box>

                            )}

                        </>

                    ) : (

                        <Box sx={{ mt: 2 }}>

                            {/* FILTER BAR */}

                            <FiltersBar
                                filters={filters}
                                onCategoryClick={() => setCategoryModal(true)}
                                onBranchClick={() => setBranchModal(true)}
                                onCategoryTypeClick={() => setTypeModal(true)}
                            >

                                {/* CATEGORY */}

                                {/* <FormControl size="small" sx={{ minWidth: 140 }}>

                                <InputLabel>
                                    Category
                                </InputLabel>

                                <Select
                                    value={filters.category}
                                    label="Category"
                                    onChange={(e) =>
                                        setFilters(prev => ({
                                            ...prev,
                                            category: e.target.value
                                        }))
                                    }
                                >

                                    {categoryOptions.map(cat => (

                                        <MenuItem
                                            key={cat}
                                            value={cat}
                                        >
                                            {cat}
                                        </MenuItem>

                                    ))}

                                </Select>

                            </FormControl> */}

                                {/* BRANCH */}

                                {/* BRANCH */}

                                {/* <Button
                                variant="outlined"
                                onClick={() => setBranchModal(true)}
                                sx={{
                                    borderColor: "#002147",
                                    color: "#002147",
                                    textTransform: "none",
                                    fontFamily: "Poppins",
                                    "&:hover": {
                                        borderColor: "#002147",
                                        backgroundColor: "#00214710"
                                    }
                                }}
                            >
                                Branches
                            </Button> */}

                                {/* CATEGORY TYPE */}

                                {/* <FormControl
                                size="small"
                                sx={{
                                    minWidth: 160
                                }}
                            >

                                <InputLabel>
                                    Category Type
                                </InputLabel>

                                <Select
                                    value={filters.type}
                                    label="Category Type"
                                    onChange={(e) =>
                                        setFilters(prev => ({
                                            ...prev,
                                            type: e.target.value
                                        }))
                                    }
                                >

                                    {categoryTypeOptions.map(type => (

                                        <MenuItem
                                            key={type}
                                            value={type}
                                        >
                                            {type.toUpperCase()}
                                        </MenuItem>

                                    ))}

                                </Select>

                            </FormControl> */}
                                {/* <Button
                                variant="outlined"
                                onClick={() => setBranchModal(true)}
                            >
                                Branches
                            </Button> */}

                            </FiltersBar>

                            {/* SUGGESTIONS */}

                            <SuggestionsPanel
                                loading={suggestionLoading}
                                suggestions={suggestions}
                                currentList={currentList}
                                onAdd={handleSuggestionAdd}
                            />
                        </Box>

                    )
                }

                {/* FAB */}

                {mode === 'list' && (
                    <Tooltip title="Add College Preference">
                        <Fab
                            variant="extended"
                            onClick={() => setCollegeModalOpen(true)}
                            sx={{
                                position: "fixed",
                                bottom: 30,
                                right: 30,
                                color: "#fff",
                                backgroundColor: "#002147",
                                px: 2.5,
                                boxShadow: 4,
                                textTransform: "none",
                                "&:hover": {
                                    backgroundColor: "#00152e"
                                }
                            }}
                        >
                            <AddIcon sx={{ mr: 1 }} />
                            College
                        </Fab>
                    </Tooltip>
                )
                }
                <AddCollegeModal
                    open={collegeModalOpen}
                    onClose={() => setCollegeModalOpen(false)}
                    colleges={collegeOptions}
                    onSelect={handleSelectCollege}
                />

                <BranchSelectModal
                    open={branchModalOpen}
                    onClose={() => setBranchModalOpen(false)}
                    branches={selectedCollege?.branches || []}
                    onSelect={handleSelectBranch}
                />
                <AddCollegeModal
                    open={allotmentModalOpen}
                    onClose={() => setAllotmentModalOpen(false)}
                    colleges={collegeOptions}
                    onSelect={handleAllotmentCollegeSelect}
                />

                <BranchSelectModal
                    open={allotmentBranchModalOpen}
                    onClose={() => setAllotmentBranchModalOpen(false)}
                    branches={allotmentCollege?.branches || []}
                    onSelect={handleAllotmentBranchSelect}
                />
                <MultiSelectDialog
                    open={branchModal}
                    onClose={() => setBranchModal(false)}
                    options={branchOptions}
                    selected={filters.branch}
                    onChange={(value) =>
                        setFilters(prev => ({
                            ...prev,
                            branch: value
                        }))
                    }
                    title="Select Branches"
                />
                <MultiSelectDialog
                    open={categoryModal}
                    onClose={() => setCategoryModal(false)}
                    options={categoryOptions}
                    selected={[filters.category]}
                    onChange={(value) =>
                        setFilters(prev => ({
                            ...prev,
                            category: value[value.length - 1]
                        }))
                    }
                    title="Select Category"
                />
                <MultiSelectDialog
                    open={typeModal}
                    onClose={() => setTypeModal(false)}
                    options={categoryTypeOptions}
                    disabled={userDetail?.predictorType == "jee"}
                    selected={[filters.type]}
                    onChange={(value) =>
                        setFilters(prev => ({
                            ...prev,
                            type: value[value.length - 1]
                        }))
                    }
                    title="Select Category Type"
                />
                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={4000}
                    anchorOrigin={{
                        vertical: "bottom",  // "top",
                        horizontal: "center"
                    }}
                    onClose={() =>
                        setSnackbar(prev => ({
                            ...prev,
                            open: false
                        }))
                    }
                >

                    <Alert
                        // variant="filled"
                        severity={snackbar.severity}
                        sx={{
                            textAlign: "center",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "1.37rem",
                            alignItems: "center",
                            boxShadow: "0 8px 24px rgba(0,0,0,0.18)",

                            "& .MuiAlert-message": {
                                width: "100%",
                                textAlign: "center"
                            }

                        }}
                    >

                        {snackbar.message}

                    </Alert>

                </Snackbar>
            </div>
        </Box >
    );
};
const backButtonStyle = {
    padding: "5px 10px",
    fontSize: 12,
    cursor: "pointer",
    borderRadius: 5,
    color: "#fff",
    border: '1px solid #002147',
    backgroundColor: '#002147',
    fontFamily: "Poppins",
};

export default PreferenceList;